module.exports = __webpack_public_path__ + "static/img/p1_img3.f548968.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p1_img3.png
// module id = iQqq
// module chunks = 0